import styled, { css } from 'styled-components';
import { Alignment } from './HeadlessTextArea';
import { TextAlignment } from '../../../enum/EnumRepository';
import TextareaAutosize from 'react-textarea-autosize';

// Naming convention:
// Do not naming when it used for
// Do naming explain their characteristics
// Do not setting position value. why? position is depends in situation.
// cursor: pointer is default.

const commonTextAreaStyles = css`
  width: 100%;
  height: fit-content;
  min-height: 20px;
  background-color: transparent;
  resize: none;
  border-radius: 0;
  overflow-y: auto; 
  overflow-x: hidden;
  &::-webkit-scrollbar { width: 3px; }
  &::-webkit-scrollbar-track { background: transparent; }
  &::-webkit-scrollbar-thumb { background: #bfbfbf; border-radius: 1px; }
  &:focus {
    outline: none;
  }
`;

const borderBottom = css`
  border: none;
  border-bottom: 1px solid ${({ theme }) => theme.colors.color_Gray_04};
  color: ${({ theme }) => theme.colors.color_Gray_03};
`;

const normalPadding = css`
  padding-bottom: 4px;
  margin-top: 14px;
`;

const normalFontSize = css`
  ${({ theme }) => theme.typography.Body_03_2};
  line-height: 1.4;
`;
const smallFontSize = css`
  ${({ theme }) => theme.typography.Body_04};
  line-height: 1.2;
`;

// 사용처:
// SupportModal
// Document
export const NormalTextArea = styled(TextareaAutosize)`
  ${commonTextAreaStyles}
  ${borderBottom}
  ${normalPadding}
  ${normalFontSize}
`;

// 사용처:
// WorkViewer, WorkViewerMobile
// MemberInfo
export const NormalSmallTextArea = styled(TextareaAutosize)`
  ${commonTextAreaStyles}
  ${borderBottom}
  ${normalPadding}
  ${smallFontSize}
`;

// 사용처:
// WorkViewer Material (soft wrap, Enter 불가)
export const WorkViewerInfoTextArea = styled(TextareaAutosize)`
  ${commonTextAreaStyles}
  ${borderBottom}
  ${smallFontSize}
  padding: 4px 0px;
  min-height: 0;
  height: auto;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  word-break: break-word;
  overflow: hidden;
  &::-webkit-scrollbar {
    display: none;
  }
`;

// 사용처:
// WorkInfo(PE) Material (soft wrap, Enter 불가)
export const InputWorkTextArea = styled(TextareaAutosize)<{ $alignment: Alignment }>`
  ${commonTextAreaStyles}
  ${borderBottom}
  ${smallFontSize}
  padding: 2px 0px;
  min-height: 0;
  height: auto;
  text-align: ${({ $alignment }) => getAlignment($alignment)};
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  word-break: break-word;
  overflow: hidden;
  &::-webkit-scrollbar {
    display: none;
  }
`;

// 사용처:
// MoleculeValue (Career content / contentEn)
export const MemberInfoValueTextArea = styled(TextareaAutosize)`
  ${commonTextAreaStyles}
  padding: 2px 0px;
  border: none;
  border-bottom: 1px solid ${({ theme }) => theme.colors.color_Gray_04};
  color: ${({ theme }) => theme.colors.color_Gray_03};
  ${({ theme }) => theme.typography.Body_04};
  line-height: 1.3;
  overflow: hidden;
  &::-webkit-scrollbar {
    display: none;
  }
`;

// 사용처:
// TextBox
export const NormalTextAreaWithAlignment = styled(TextareaAutosize)<{ $alignment: Alignment }>`
  ${commonTextAreaStyles}
  ${borderBottom}
  ${normalPadding}
  ${normalFontSize}
  text-align: ${({ $alignment }) => getAlignment($alignment)};
`;

export const NormalTextAreaWithAlignmentMobile = styled(TextareaAutosize)<{ $alignment: Alignment }>`
  ${commonTextAreaStyles}
  ${borderBottom}
  ${normalPadding}
  ${normalFontSize}
  text-align: ${({ $alignment }) => getAlignment($alignment)};
`;


export const getAlignment = (alignment: Alignment): string => {
  switch (alignment) {
    case TextAlignment.LEFT:
      return 'left';
    case TextAlignment.CENTER:
      return 'center';
    case TextAlignment.RIGHT:
      return 'right';
    default:
      return 'center';
  }
};